import React, { useState, useEffect, useRef, useMemo } from "react";
import { Container, Row, Col, Table, Form, Modal, Button } from "react-bootstrap";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import { format } from "date-fns";
import { EYE, PDF, CSV, XLSXICON, INFO, PDF2 } from "../../../components/iconsSVG/IconsSVG";
import { es } from "date-fns/locale";
import Spinner from "../../../components/spinner/spinner";
import { getBuscarAnotaciones } from '../../../services/buscarTomos';
import { getURLFront } from "../../../api/api";

import "./resultadosBusquedaTomos.css";

import { verAviso } from "../../../components/VerAviso/VerAviso";

import {
  descargarDocumentoPdfCompleto,
} from "../../../services/publicacionesBopiService";


const ResultadosTabla = ({ resultados, parametros, resultadosTotales }) => {

  const getId = (r) => `${r.modalidad}_${r.num_EXPEDIENTE}`;

  const fechaConsulta = format(new Date(), "EEEE, d 'de' MMMM 'de' yyyy", {
    locale: es,
  });
  const [columnasSeleccionadas, setColumnasSeleccionadas] = useState([
    { value: "fecha_PUBLICACION", label: "Fecha publicación" },
    { value: "num_expediente", label: "Expediente" },
    { value: "tipoAnotaciones", label: "Tipo de publicación" }
  ]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [show, setShow] = useState(false);
  const [seleccionados, setSeleccionados] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [ordenColumna, setOrdenColumna] = useState("");
  const [ordenAscendente, setOrdenAscendente] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [registrosSeleccionados, setRegistrosSeleccionados] = useState([]);

  const contadorRef = useRef(20);
  const [todosResultados, setTodosResultados] = useState([]);
  const [visibleCount, setVisibleCount] = useState(20);

  const [baseURL, setBaseURL] = useState(null);
  const [loading, setLoading] = useState(true);

  function SortIcon({ asc }) {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" className="SortIcon">
        <path
          d={asc ? "M12 20V5 M7 11l5-5 5 5" : "M12 5v13 M7 13l5 5 5-5"}
          fill="none"
          stroke="#8c8c8c"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  const handleSort = async (columna) => {
    const nuevoOrdenAscendente = ordenColumna === columna ? !ordenAscendente : true;
    const nuevoValorOrden = nuevoOrdenAscendente ? 1 : 0;
  
    setIsLoadingMore(true);
    setTodosResultados([]);
    setVisibleCount(0);
    contadorRef.current = 0;
  
    setSeleccionados([]);
    setSelectAll(false);
    setRegistrosSeleccionados([]);
  
    await new Promise((r) => setTimeout(r, 300));
  
    try {
      const nuevosResultados = await getBuscarAnotaciones(
        parametros,
        0,
        20,
        columna,
        nuevoValorOrden
      );
  
      contadorRef.current = 20;
      setOrdenColumna(columna);
      setOrdenAscendente(nuevoOrdenAscendente);
      setTodosResultados(nuevosResultados);
      setVisibleCount(20);
    } finally {
      setIsLoadingMore(false);
    }
  };

  const handleExportPDF = (fechaConsult, numeroResultado) => {
    const fechaConsulta = fechaConsult;
    const numeroResultados = numeroResultado;

    if (!registrosSeleccionados || registrosSeleccionados.length === 0) {
      // alert("No hay registros seleccionados.");
      verAviso("No hay registros seleccionados.");
      return;
    }

    const img = new Image();
    img.src = process.env.PUBLIC_URL + '/logoministerio-agenda.png';

    img.onload = () => {
      const doc = new jsPDF();

      const imgX = 14;
      const imgY = 10;
      const imgWidth = 70;
      const imgHeight = 10;

      // Agrega la imagen
      doc.addImage(img, 'PNG', imgX, imgY, imgWidth, imgHeight);

      doc.setFontSize(12);
      const pageWidth = doc.internal.pageSize.getWidth();
      const textY = imgY + 6;

      doc.text('CONSULTA DE EXPEDIENTES OEPM', pageWidth - 14, textY, { align: 'right' });

      doc.setFontSize(10);
      doc.text('Fecha de consulta: ' + fechaConsulta, 14, textY + 15);
      doc.text('Número de resultados: ' + numeroResultados, 14, textY + 20);

      const headers = columnasSeleccionadas.map(columna => columna.label);

      const rows = registrosSeleccionados.map(resultado =>
        columnasSeleccionadas.map(columna =>
          columna.value === "num_expediente"
            ? resultado.modalidad + " - " + resultado.num_EXPEDIENTE
            : resultado[columna.value]
        )
      );

      autoTable(doc, {
        head: [headers],
        body: rows,
        theme: 'striped',
        startY: imgY + 10 + imgHeight + 10, 
        margin: { top: 14 },
        headStyles: { fillColor: '#203C77', textColor: '#fff' },
        didDrawPage: (data) => {
        },
      });


      const pageCount = doc.internal.getNumberOfPages();
      const pageWidthFinal = doc.internal.pageSize.getWidth();
      const pageHeightFinal = doc.internal.pageSize.getHeight();
      const marginRight = 14;

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);

        const footerText = `Página ${i} de ${pageCount}`;
        const centerText = "© 2025. Oficina Española de Patentes y Marcas";

        doc.text(footerText, pageWidthFinal - marginRight, pageHeightFinal - 10, { align: 'right' });
        doc.text(centerText, pageWidthFinal / 2, pageHeightFinal - 10, { align: 'center' });
      }

      doc.save('resultados.pdf');
    };

    img.onerror = () => {
      // alert('No se pudo cargar la imagen del logo.');
      verAviso("No se pudo cargar la imagen del logo.");
    };
  };

  const handleExportXLSX = () => {
    if (!registrosSeleccionados || registrosSeleccionados.length === 0) {
      // alert("No hay registros seleccionados.");
      verAviso("No hay registros seleccionados.");
      return;
    }
  
    // Construimos los datos en formato de array de objetos
    // const datosParaExcel = registrosSeleccionados.map(reg => {
    //   let fila = {};
    //   columnasSeleccionadas.forEach(col => {
    //     fila[col.label] = reg[col.value] || ""; 
    //   });
    //   return fila;
    // });
  
    const datosParaExcel = registrosSeleccionados.map(resultado => 
      Object.fromEntries(columnasSeleccionadas.map(columna => [columna.label, columna.value === "num_expediente" ? resultado.modalidad + " - " + resultado.num_EXPEDIENTE : (resultado[columna.value] || "")
    ])));

    // Crear hoja de trabajo (worksheet) y libro de Excel (workbook)
    const worksheet = XLSX.utils.json_to_sheet(datosParaExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
  
    // Generar el archivo en formato binario
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
    // Convertir el archivo y forzar su descarga
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(data, "exportacion.xlsx");
  };

  const handleExportCSV = () => {
    if (!registrosSeleccionados || registrosSeleccionados.length === 0) {
      // alert("No hay registros seleccionados.");
      verAviso("No hay registros seleccionados.");
      return;
    }
  
    // Extraer los encabezados de la tabla
    const headers = columnasSeleccionadas.map(col => col.label).join(";");
  
    const csvContent = [
      headers, 
      ...registrosSeleccionados.map(resultado => columnasSeleccionadas.map(columna => columna.value === "num_expediente" ? resultado.modalidad + " - " + resultado.num_EXPEDIENTE : resultado[columna.value]).join(";"))
    ].join("\n");

    // Crear un blob y descargar el archivo
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "exportacion.csv");
  };

  const handleOjoClick = () => {
    if (registrosSeleccionados.length === 0 || hayXmlInvalido) {
      // alert("O bien no hay registros seleccionados, o bien ha seleccionado algunos que no tienen datos que se puedan mostrar (debido a su antigüedad, etc, por lo que no aparece el icono en esas líneas).");
      verAviso("O bien no hay registros seleccionados, o bien ha seleccionado algunos que no disponen de datos que se puedan mostrar (debido a su antigüedad, etc, por lo que no aparece el icono de detalle en esas líneas).");
      return;
    }
  
    const nuevaVentana = window.open(
      baseURL+"/detalleMarcadas",
      "detalleMarcadas",
      "width=800,height=600"
    );

    const checkReady = setInterval(() => {
      if (nuevaVentana && nuevaVentana.__isReady) {
        clearInterval(checkReady);

          nuevaVentana.postMessage(
            {type: "registrosSeleccionados",  registros: registrosSeleccionados }, 
            baseURL+"/detalleMarcadas"
          );
        // };
      };
    });
  };

  useEffect(() => {
    getURLFront().then(url => {
      setBaseURL(url);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    setTodosResultados(resultados);
    setVisibleCount(20);
    contadorRef.current = 20;
    setSeleccionados([]);
  }, [resultados]);

  const datosOrdenados = useMemo(() => {
    let datos = [...todosResultados];

    if (ordenColumna) {
      datos.sort((a, b) => {
        const valA = ordenColumna === "num_expediente"
          ? `${a.modalidad} - ${a.num_EXPEDIENTE}`
          : a[ordenColumna];

        const valB = ordenColumna === "num_expediente"
          ? `${b.modalidad} - ${b.num_EXPEDIENTE}`
          : b[ordenColumna];

        if (!isNaN(valA) && !isNaN(valB)) {
          return ordenAscendente ? valA - valB : valB - valA;
        }

        return ordenAscendente
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });
    }

    return datos;
  }, [todosResultados, ordenColumna, ordenAscendente]);

  useEffect(() => {
    const seleccionadosReales = datosOrdenados.filter(r =>
      seleccionados.includes(getId(r))
    );
    setRegistrosSeleccionados(seleccionadosReales);

  }, [seleccionados, datosOrdenados]);

  const toggleSelect = (resultado) => {
    const id = getId(resultado);

    if (seleccionados.includes(id)) {
      setSeleccionados(seleccionados.filter(i => i !== id));
    } else {
      setSeleccionados([...seleccionados, id]);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSeleccionados([]);
    } else {
      setSeleccionados(datosOrdenados.slice(0, visibleCount).map(r => getId(r)));
    }
    setSelectAll(!selectAll);
  };

  const handleViewPDF = (resultado) => {
    const nuevaVentana = window.open(baseURL + "/visorPdf", "visorPdf", "width=800,height=600");

    const handleReady = (event) => {
      const urlCompleta = new URL("/bopi", event.origin).href;

      if (urlCompleta === baseURL && event.data.tipo === "visorPdfReady") {
        event.source.postMessage({ resultado }, baseURL);
        window.removeEventListener("message", handleReady);
      }
    };

    window.addEventListener("message", handleReady);
  };

  const handleViewPDFCompleto = async (resultado) => {
    try {
      console.log("resultado.fecha_PUBLICACION: ", resultado.fecha_PUBLICACION)
      console.log("resultado.tomo: ", resultado.tomo)
      await descargarDocumentoPdfCompleto(resultado.fecha_PUBLICACION,resultado.tomo);
    } catch (error) {
      console.error("Error descargando el documento pdfCompleto - resultadosBusquedaTomos:", error);
    }
  };

  const handleOjoEspecificoClick = (resultado) => {
    const nuevaVentana = window.open(baseURL + "/detalleMarcadas", "_blank", "width=800,height=600");

    const checkReady = setInterval(() => {
      if (nuevaVentana && nuevaVentana.__isReady) {
        clearInterval(checkReady);
        nuevaVentana.postMessage({ type: "registrosSeleccionados", resultado }, baseURL + "/detalleMarcadas");
      }
    });
  };

  const handleEnlaceClick = (resultado) => {
    let expediente = resultado.num_EXPEDIENTE.split("(")[0];
    expediente = expediente.split("-")[0];
    expediente = expediente.trim();

    window.open(
      `https://ceo.oepm.es/detalleExpediente?numExp=${resultado.modalidad}${expediente}`,
      "_blank"
    );
  };

  useEffect(() => {
    const handleScroll = async () => {
      const scrollable = document.documentElement;

      if (scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - 100) {
        if (visibleCount < resultadosTotales && !isLoadingMore) {

          setIsLoadingMore(true);

          const nuevosResultados = await getBuscarAnotaciones(
            parametros,
            contadorRef.current,
            20,
            ordenColumna,
            ordenAscendente ? 1 : 0
          );

          contadorRef.current += 20;

          const nuevosTodosResultados = [...todosResultados, ...nuevosResultados];
          setTodosResultados(nuevosTodosResultados);

          setTimeout(() => {
            setVisibleCount(prev => Math.min(prev + 20, nuevosTodosResultados.length));
            setIsLoadingMore(false);
          }, 500);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);

  }, [visibleCount, todosResultados.length, isLoadingMore]);

  if (loading) return <div>Cargando...</div>;

  function esXmlValido(xmlString) {
    if (!((xmlString || "").trim())) return false;
    if (xmlString.trim().substring(0, 6) == 'es.dxd' || xmlString.trim().substring(0, 6) == '1')  return false;

    return true;

  }

  const hayXmlInvalido = registrosSeleccionados.some(r => 
    !esXmlValido(r.xml_ANOTACION)
  );
  
  return (
    <div>
      {/* <Container className="m-0 p-0"> */}

        {/* <div className="espacios-generales m-0 p-0"> */}

          <Row className="espacios-generales m-0 p-0 d-flex flex-wrap pt-3">

            {/* IZQUIERDA */}
            <Col
              xs={12}
              md={9}
              className="p-2 m-0 d-flex align-items-center shadow text-break"
            >
              <p className="p-0 m-0 text-start w-100">
                &nbsp;Fecha de consulta:&nbsp;
                <strong>
                  {fechaConsulta}
                </strong>
                {resultadosTotales !== null && (
                  <>
                    ,&nbsp;{resultadosTotales}&nbsp;resultados encontrados
                  </>
                )}
              </p>
            </Col>

            {/* DERECHA */}
            <Col
              xs={12}
              md={3}
              className="p-2 m-0 d-flex justify-content-start justify-content-md-end align-items-center flex-wrap "
            >


              <Button
                onClick={() => handleExportPDF(fechaConsulta, registrosSeleccionados.length)}
                className="btn-blanco-icono p-0 m-0"
              >
                <PDF width={25} height={25} />
              </Button>


              <Button onClick={handleExportXLSX}
                className="btn-blanco-icono p-0 m-0"
              >
                <XLSXICON width={25} height={25} />
              </Button>

              <Button onClick={handleExportCSV}
                className="btn-blanco-icono p-0 m-0"
              >
                <CSV width={25} height={25} />
              </Button>

              <Button onClick={handleOjoClick}
                className="btn-blanco-icono p-0 m-0"
              >
                <EYE width={29} height={24} color_icono="#203C77" color_fondo="transparent" />
              </Button>
              <Button onClick={handleShow} className="fondo-blanco-icono p-0 m-0 pt-2">
                <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
              </Button>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  Una vez seleccionadas las publicaciones del listado de resultados,
                  si se elige exportar en formato PDF, XLSX o CSV se exportará el listado de las publicaciones
                  seleccionadas en el formato correspondiente, no el detalle de las publicaciones.
                </Modal.Body>
              </Modal>
            </Col>

          </Row>

        {/* </div> */}

        <br />        
       
        <Row className="m-0 p-0 d-flex flex-wrap pt-3">
          <Col 
              xs={12}
              className="m-0 p-0">
            <div className="shadow m-0 p-0  overflow-auto">

              <div className="p-3">
                <Table className="table-sm" style={{ whiteSpace: "nowrap" ,   minWidth: "800px"}}>

                  <thead>
                    <tr>
                      <th className="bopi-table">
                        <Form.Check checked={selectAll} onChange={toggleSelectAll} />
                      </th>

                      <th
                        className={`bopi-table align-top sortable ${ordenColumna === "fecha_PUBLICACION" ? "active" : ""}`}
                        onClick={() => handleSort("fecha_PUBLICACION")}
                      >
                        Fecha publicación <SortIcon asc={ordenColumna === "fecha_PUBLICACION" ? ordenAscendente : true} />
                      </th>

                      <th
                        className={`bopi-table align-top sortable ${ordenColumna === "num_expediente" ? "active" : ""}`}
                        onClick={() => handleSort("num_expediente")}
                      >
                        Expediente <SortIcon asc={ordenColumna === "num_expediente" ? ordenAscendente : true} />
                      </th>

                      <th
                        className={`bopi-table align-top sortable ${ordenColumna === "tipoAnotaciones" ? "active" : ""}`}
                        onClick={() => handleSort("tipoAnotaciones")}
                      >
                        Tipo de publicación<SortIcon asc={ordenColumna === "tipoAnotaciones" ? ordenAscendente : true} />
                      </th>
                      <th className="bopi-table"></th>
                    </tr>
                  </thead>

                  <tbody>
                    {datosOrdenados.slice(0, visibleCount).map((r, i) => (
                      <tr key={i}>

                        <td className="pt-2">
                          <Form.Check
                            checked={seleccionados.includes(getId(r))}
                            onChange={() => toggleSelect(r)}
                          />
                        </td>

                        <td className="pt-2">{r.fecha_PUBLICACION}</td>
                        <td className="pt-2">{r.modalidad} - {r.num_EXPEDIENTE}</td>
                        <td className="pt-2">{r.tipoAnotaciones}</td>

                        <td className="pt-0">

                          <Button onClick={() => handleViewPDF(r)} className="btn-blanco-icono">
                            <PDF />
                          </Button>

                          {esXmlValido(r.xml_ANOTACION) && (
                            <Button onClick={() => handleOjoEspecificoClick(r)} className="btn-blanco-icono">
                              <EYE color_icono="#203C77" color_fondo="transparent" />
                            </Button>
                          )}

                          <span onClick={() => handleEnlaceClick(r)} style={{ cursor: 'pointer' }}>
                            <img src="/bopi/ceo.jpg" className="mt-2 logo-busqueda" />
                          </span>

                          <Button onClick={() => handleViewPDFCompleto(r)} className="mt-1 btn-blanco-icono">
                            <PDF2 />
                          </Button>

                        </td>

                      </tr>
                    ))}
                  </tbody>

                </Table>

                {isLoadingMore && <Spinner />}
              </div>

            </div>
          </Col>

        </Row>
        
      {/* </Container> */}
    </div>
  );
};

export default ResultadosTabla;
